import API from "../api/axios";

// ─── Get All Sales ───
export const getAllSales = () => {
   return API.get("/sales");
};

// ─── Update Sale ───
export const updateSale = (id, data) => {
   return API.put(`/sales/${id}`, data);
};